import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import MaskIcon from '../../../../icons/Mask.svg';
import WalletIcon from '../../../../icons/wallet.svg';
import ButtonInputForPolicy from '../SubComponent/ButtonInputForPolicy';
import Button from '@material-ui/core/Button';

const buttonData = [
    {
        icon: MaskIcon,
        title: 'Child Rider',
        infoText: "Additional benefit option to provide life insurance on a client's children while they are young. It can be converted to a permanent policy at a later time. "
    },
    {
        icon: WalletIcon,
        title: 'Accidental Death Benefit',
        subtitle: 'Provides coverage that pays an additional death benefit,if death results from an accident.'
    },
    {
        icon: WalletIcon,
        title: 'Accelerated Death Benefit',
        subtitle: "This benefit allows a terminally ill customer to receive an advance of their policy's death benefit while still alive."
    },
    {
        icon: WalletIcon,
        title: 'Waiver of Premium',
        subtitle: "Under certain conditions, the premium payment may be waived in the event the primary insured becomes totally disabled as defined in the rider."
    }
];

export default function PolicyRider(props) {
    useEffect(() => {
        // control the Checkbox based on if knockouts are selected
        var selected = false;
        props.formState.knockouts.forEach((k) => {
            selected = selected || k
        });
    }, [props.formState.knockouts]);

    const handleValueChange = (value, index) => {
        var stateCopy = props.formState.knockouts.slice(0);
        stateCopy[index] = value;
        props.onFieldChange("knockouts", stateCopy);
    };

    const handleDropDownChange = (value, e) => {
        props.onFieldChange(value, e);

    }

    const handleFirstIndex = (index) => {
        if (index === 0)
            return true;
        else
            return false
    }
    return (
        <Container fluid className='border-class'>
            <Form onSubmit={props.onNext}>
                <Row className='w-100 '>
                    <Col sm={12}>
                        <h4 className='justify-content-center text-center mt-5'>Add policy riders</h4>
                    </Col>
                </Row>
                <Row className='w-100 '>
                    <Col sm={12}>
                        <h6 className='justify-content-center text-center mt-2'>Enhance your client's coverage by adding additional benefits.</h6>
                    </Col>
                </Row>
                <Row className="justify-content-center no-gutters mb-5" role="group" aria-labelledby="Background">
                    {buttonData.map((d, index) =>
                        <Col xs="auto" key={index} className="d-flex mr-3 justify-content-center btn-wrapper">
                            <ButtonInputForPolicy
                                icon={d.icon}
                                title={d.title}
                                subtitle={d.subtitle}
                                infoText={d.infoText}
                                index={index}
                                isFirstIndex={handleFirstIndex}
                                value={props.formState.knockouts[index]}
                                handleValueChange={handleValueChange}
                                handleDropDownChange={handleDropDownChange}
                                benefitAmount={props.formState.benefitAmount}
                            />
                        </Col>
                    )}
                </Row>
                <Row className="pt-5 mb-4 mx-2">
                    <Col className="text-left btn-back">
                        <Button variant="outlined" size="medium" color="primary" onClick={props.onBack} >BACK</Button>
                    </Col>
                    <Col className="text-right btn-borderless">
                        <Button variant="outlined" size="medium" color="primary" className='mr-4' onClick={props.onNext} >SKIP TO RESULTS</Button>
                        <Button variant="contained" size="medium" color="primary" disabled={!props.formState.knockouts.includes(true)} type="submit">PERSONALIZE RATES</Button>
                    </Col>
                </Row>
            </Form>
        </Container>
    )
}

PolicyRider.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
};

PolicyRider.DefaultFormState = (prefill = false) => {
    return {
        knockouts: [...Array(buttonData.length).keys()].map((i) => false),
        benefitAmount: prefill ? "5000" : "5000"
    };
};


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/steps/PolicyRider.js